<template>
  <div class="container print-order">
    <b-overlay :show="loading" opacity="0.99">
      <ErrorsMessages :errors="errors" />
      <table class="bg-white" v-show="errors.length == 0">
        <thead>
          <div class="header-space">
            <div class="row">
              <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 pt-1 pb-0">
                <img
                  v-if="rest_home_logo_url"
                  class="rest_home_logo_url"
                  :src="rest_home_logo_url"
                />
                <div v-if="!rest_home_logo_url" class="ml-1">
                  <strong class="text-uppercase">{{ rest_home_name }}</strong>
                </div>
              </div>
              <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 pt-1 pb-0">
                <div class="row">
                  <img
                    v-if="order.resident_photo_url"
                    class="resident_photo_url"
                    :src="order.resident_photo_url"
                  />
                  <img
                    v-if="!order.resident_photo_url"
                    class="resident_photo_url"
                    :src="require('../../../../assets/user.png')"
                  />
                  <div class="ml-5 mt-2">
                    <h6 class="mb-0">
                      {{ order.resident_name }}
                    </h6>
                    <h6 class="mb-0 worksansr upper-text">
                      Data de nascimento:
                      {{ formatDate(order.resident_date_of_birth, false) }}
                      -
                      {{ getAge(order.resident_date_of_birth) }}
                      anos
                    </h6>
                    <h6 class="mb-0 worksansr upper-text">
                      Data de admissão:
                      {{ formatDate(order.resident_date_of_reception, false) }}
                    </h6>
                  </div>
                </div>
              </div>
              <div
                class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 pt-1 pb-0 check-text-right"
              >
                <img class="logo" :src="logo" width="180" />
                <br />
                <span>
                  Data:
                  {{ formatDate(order.created_at, false) }}
                </span>
              </div>
              <div class="col-md-12 pt-0 pb-0">
                <!-- IDENTIFICAÇÃO DO EMITENTE -->
                <div class="identificacao-do-emitente row m-0">
                  <div class="identificacao-do-emitente-left col-md-7">
                    <h4>IDENTIFICAÇÃO DO EMITENTE</h4>
                    <div><b>Nome:</b> {{ order.user_name }}</div>
                    <div>
                      <b>CRM:</b>
                      {{ order.user_professional_class_council_value }}
                    </div>
                    <div>
                      <b>Endereço:</b> {{ order.rest_home_address }}
                      {{ order.rest_home_num_address }}
                    </div>
                    <div>
                      <b>Telefone:</b>
                      {{
                        order.rest_home_first_phone
                          ? order.rest_home_first_phone
                          : order.rest_home_second_phone
                      }}
                    </div>
                    <div>
                      <b>Cidade e UF:</b> {{ order.rest_home_city }} -
                      {{ order.rest_home_uf_name }}
                    </div>
                  </div>
                </div>
                <!-- IDENTIFICAÇÃO DO EMITENTE -->
              </div>
            </div>
          </div>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="page-break-inside-avoid">
                <p class="text-center m-0 order-title">
                  {{ order.title }}
                </p>
                <vue-editor v-model="order.text" />
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <div class="footer-space">
                <div class="text-center">
                  <hr />
                  (Assinatura eletrônica)
                  {{
                    professionalClassCouncilValue({
                      id: order.user_professional_class_council_id,
                      name: order.user_name,
                      profile: order.user_profile_name,
                      cpf: order.user_cpf,
                      office: order.user_office,
                      value: order.user_professional_class_council_value,
                    })
                  }}
                  <small> - {{ formatDate(order.created_at) }} </small>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
      <v-btn
        class="btn-print float-right mt-2"
        v-show="errors.length == 0"
        v-on:click="printOut"
        >Imprimir</v-btn
      >
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import { VueEditor } from "vue2-editor";

import api from "../../../../services/api";

import {
  formatDate,
  professionalClassCouncilValue,
} from "../../../../lib/format";

import { getAge } from "../../../../lib/getAgeByDate";

import { userData } from "../../../../lib/functions";

import routes from "../../../../routes";

import moment from "moment";

export default {
  name: "PrintResidentOrder",

  components: {
    ErrorsMessages,
    VueEditor,
  },

  data() {
    return {
      id: "",

      errors: [],

      order: {},

      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,

      logo: null,

      loading: true,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    moment,
    getAge,
    formatDate,
    professionalClassCouncilValue,

    async retrieve() {
      const { id } = routes.history.current.params;

      this.id = id;

      let { user, logo } = userData();

      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      await this.get();
    },

    async get() {
      try {
        this.loading = true;

        const { id } = this;

        var params = { id };

        const response = await api.get("/rest-home/resident/order", {
          params,
        });

        const { error, errors, order } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.order = order;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    printOut: () => window.print(),
  },
};
</script>

<style>
.print-order .logo {
  height: 50px;
  object-fit: contain;
}

.print-order .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.print-order .resident_photo_url {
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
}

.print-order .order-title {
  font-size: 35px;
  text-transform: uppercase !important;
  margin-bottom: 20px !important;
}

.print-order .order-text {
  font-size: 35px;
}

@media print {
  @page {
    size: 0;
  }

  .print-order button {
    display: none;
  }

  .print-order .page-break-inside-avoid {
    page-break-inside: avoid !important;
  }

  .print-order .identificacao-do-emitente-left {
    width: 60% !important;
  }
}

/* ------------- */

.print-order .identificacao-do-emitente-left {
  border: solid 3px #000;
  padding: 2px !important;
  box-sizing: border-box;
}

.print-order .identificacao-do-emitente-left h4 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  text-align: center !important;
}

.print-order .footer-space {
  height: 50px;
}
</style>